import WarehouseDataState from "@crescentParts/Store/Data/WarehouseData/WarehouseDataState"
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer"

const initialState = {
    warehouseData: null,
    selectedWarehouse: ""
}

const reducer = {
    "Custom/WarehouseData/setWarehouseData": (draft: Draft<WarehouseDataState>, action: { warehouseData: [] }) => {
        draft.warehouseData = action.warehouseData;
    },
    "Custom/WarehouseData/setSelectedWarehouse": (draft: Draft<WarehouseDataState>, action: { param: string }) => {
        draft.selectedWarehouse = action.param;
    }
}



export default createTypedReducerWithImmer(initialState, reducer);